<div class="row content_body-inner clinic_submitted">
    <div class="col-lg-12 d-flex align-items-top pt-5">
        <div class="container pt-5">
            <div class="row pt-5">
                <div class="col-lg-4 col-md-12 clinic_submitted-left pt-1">                 
                    <!-- <h1 *ngIf="!isMobile" aria-label="Your request was submitted"  autofocus >Your request was submitted!</h1> -->
                    <label *ngIf="!isMobile" tabindex="0" #focus2  autofocus  style="font-size: 36px; color: white;" >Your request was submitted!</label>
                    <label *ngIf="isMobile" class="sr-only"  tabindex="0" #focus2  autofocus  style="font-size: 36px; color: white;" >Your request was submitted!</label>
                    <!-- <input  *ngIf="isMobile"  class="visually_hidden" aria-label="Your request was submitted" /> -->
                    <!-- <button  *ngIf="isMobile"  class="visually_hidden" aria-label="Your request was submitted" > </button> -->
                    <!-- <span *ngIf="isMobile"  class="sr-only">Your request was submitted</span> -->
                    <p>
                        Thank you for taking the time to complete and submit your clinic request. We'll start working on your request and get back to you in 3-5 days to assist with the final details.
                        <br><br>
                        Questions? Contact us at <a href="mailto:vaccineclinics@albertsons.com">vaccineclinics&#64;albertsons.com</a>
                        <br><br>
                    </p>                    
                    <button type="button" tabindex="0" class="btn btn-lg btn-primary rounded-pill mb-3 mr-md-3 white" (click)="clinicDetails()">New Clinic Request</button>
                    <a tabindex="0" class="btn btn-lg btn-outline-secondary rounded-pill mb-3 white" target="_blank" [href]="learnMoreVeribage">Learn more</a>           
                </div>
                <div class="col-lg-7 col-md-12 offset-lg-1 pt-5">
                    <!-- <h5 class="text-white mb-3">Clinic Requests</h5> -->
                    <!-- <div class="clinic_card shadow mb-5">
                        <div class="clinic_card-top">
                            <span class="clinic_card-icon shadow">
                                <img src="assets/images/clinic-icon.png" width="22" height="24" alt="" />
                            </span>
                            <span class="clinic_card-requested">
                                Requested
                            </span>
                        </div>
                        <div class="clinic_card-bottom">
                            <p>
                                <span class="clinic_card-name">{{aci_clinicName}}</span>
                                <span class="clinic_card-details mb-3">{{aci_serviceImmunizatin}}</span>
                                <span class="clinic_card-title">Clinic dates</span>
                                <span class="clinic_card-date mb-3">{{aci_isthereaspecificdate}}</span>
                                <span class="clinic_card-address">
                                   {{aci_streetaddress}}
                                </span>
                                <br>
                            </p>
                        </div>
                    </div> -->
                    <div class="clinic_card shadow mb-5" *ngFor="let clinic of clinicsList; let i = index;" >
                        <div class="clinic_card-top">
                            <span class="clinic_card-icon shadow">
                                <img src="assets/images/clinic-icon.png" width="22" height="24" alt="" />
                            </span>
                              <span class="clinic_card-requested">
                                    Requested
                                </span>
                        </div>
                        <div class="clinic_card-bottom">
                            <span class="clinic_card-name">{{clinic.aci_clinicname}}</span>
                            <span class="clinic_card-details mb-3">{{ clinic['aci_immunizationtype@OData.Community.Display.V1.FormattedValue']  }} {{ clinic['aci_clinicservicetype@OData.Community.Display.V1.FormattedValue']  }}</span>
                            <span class="clinic_card-title">Clinic dates</span>
                            <span class="clinic_card-date mb-3">{{ clinic.aci_isthereaspecificdateyoudliketohold ? clinic.aci_isthereaspecificdate : 'No, Dates are flexible'}}</span>
                            <span class="clinic_card-address">
                                {{ clinic.aci_streetaddress }}
                            </span>
                           
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>